/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { FullUserViewModel } from './FullUserViewModel'; 

export function getLoggedInUserOptions(onSuccess?: (result: FullUserViewModel) => void) {
	return queryOptions({
		queryKey: ['logged-in-user'],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/libraries/users/queries/getloggedinuser/';
			const resp = await axios.get<FullUserViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: true
	});
}